import en from './englishLocale'
import pl from './polishLocale'

export default {
  en: { translation: en },
  pl: { translation: pl },
  options: {
    plural_number: '3',
    plural_rule: 'plural=(n==1 ? 0 : (n==0 ? 2 : (n%10>=2 && n%10<=4 && (n%100<10 || n%100>=20) ? 1 : 2)))',
  },
}
